import { GENETICS } from "../../lib/plan";

const Range = ({ label, value, min, max, onChange, testid, unit }) => (
  <label className="block">
    <span className="flex justify-between text-xs text-[#C9D6C2]">
      {label} <span data-testid={`${testid}-value`} className="font-mono-d text-[#F2B441]">{value} {unit}</span>
    </span>
    <input type="range" min={min} max={max} value={value} onChange={(e) => onChange(Number(e.target.value))} data-testid={testid}
      className="mt-2 w-full accent-[#F2B441] cursor-pointer" />
    <span className="flex justify-between font-mono-d text-[10px] text-[#C9D6C2]/80"><span>{min}</span><span>{max}</span></span>
  </label>
);

export const JPlanForm = ({ cfg, setCfg }) => {
  const g = GENETICS[cfg.genetic];
  const pick = (k) => setCfg({ genetic: k, growth: GENETICS[k].growth, flower: GENETICS[k].flower });
  return (
    <div data-testid="plan-form" className="rounded-[10px] label-frame bg-[#0E2A1C] p-5 md:p-7 space-y-6">
      <div>
        <p className="font-mono-d text-[11px] tracking-[0.2em] uppercase text-[#F2B441] mb-3">1 · Tu genética</p>
        <div className="grid grid-cols-2 gap-2">
          {Object.entries(GENETICS).map(([k, v]) => (
            <button key={k} onClick={() => pick(k)} data-testid={`plan-genetic-${k}`}
              className={`rounded-[8px] border p-3 text-left transition-colors ${cfg.genetic === k ? "bg-[#F2B441] text-[#0E2A1C] border-[#F2B441]" : "border-[#F6EEDC]/20 hover:border-[#F2B441]"}`}>
              <span className="block text-sm font-bold">{v.label}</span>
              <span className={`block text-[11px] mt-0.5 ${cfg.genetic === k ? "text-[#0E2A1C]/80" : "text-[#C9D6C2]"}`}>{v.growth + v.flower} semanas</span>
            </button>
          ))}
        </div>
        <p className="text-xs text-[#C9D6C2] mt-2">{g.note}</p>
      </div>
      <div>
        <p className="font-mono-d text-[11px] tracking-[0.2em] uppercase text-[#F2B441] mb-3">2 · Fecha de inicio</p>
        <input type="date" value={cfg.start} onChange={(e) => e.target.value && setCfg({ start: e.target.value })} data-testid="plan-start-date"
          className="h-11 w-full rounded-full bg-[#143823] border border-[#F6EEDC]/30 px-4 text-sm text-[#F6EEDC] [color-scheme:dark] focus:border-[#F2B441] outline-none" />
      </div>
      <div className="space-y-5">
        <p className="font-mono-d text-[11px] tracking-[0.2em] uppercase text-[#F2B441]">3 · Floración</p>
        <Range label="Semanas de floración" unit="sem" value={cfg.flower} min={7} max={12} testid="plan-flower-range"
          onChange={(v) => setCfg({ flower: v })} />
        <p className="text-[11px] text-[#C9D6C2]">{cfg.growth} semanas de crecimiento incluidas.</p>
      </div>
    </div>
  );
};
